export default [
  {
    // path: '/actionCamera/:pageType',
    path: '/actionCamera',
    redirect: '/actionCameraService',
    // component: () => import('@/views/actionCamera/Index.vue'),
    name: 'actionCamera',
    meta: {
      title: '运动相机',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/actionCamera-pay',
    component: () => import('@/views/actionCamera/PayChose.vue'),
    name: 'actionCamera-pay',
    meta: {
      title: '立即购买',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/actionCameraService',
    component: () => import('@/views/actionCamera/ActionCameraService.vue'),
    name: 'action-camera-service',
    meta: {
      title: '运动相机服务',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/cameraConnectTutorial',
    component: () => import('@/views/actionCamera/CameraConnectTutorial.vue'),
    name: 'camera-connect-tutorial',
    meta: {
      title: '运动相机服务',
      backgroundClass: 'bg-gray',
    },
  },
];
